
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {},
  name: 'SkippingCustomValidationDialog',
  emits: ['proceed', 'close'],
})
export default class SkippingCustomValidationDialog extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: '' }) message!: string
  @Prop({ default: 'Custom Validation Warning' }) title!: string

  closeDialog() {
    this.$emit('close')
  }

  proceedAnyway() {
    this.$emit('proceed')
  }
}
